import { motion } from "framer-motion";

const items = [
  "Handpans",
  "Gongs",
  "Koshi",
  "Bols tibétains",
  "Arbres de pluie",
  "Carillons",
  "Sonothérapie",
  "Bains sonores",
  "Méditation",
  "Compiègne",
];

export default function Marquee() {
  const all = [...items, ...items].map((label, i) => ({
    key: `${label}-${i < items.length ? "a" : "b"}`,
    label,
  }));
  return (
    <section
      className="py-8 border-y border-ink/10 bg-cream overflow-hidden"
      data-testid="marquee"
    >
      <div className="relative flex whitespace-nowrap">
        <div className="flex animate-marquee gap-12">
          {all.map((item) => (
            <div key={item.key} className="flex items-center gap-12 shrink-0">
              <span className="font-serif italic-serif text-3xl md:text-5xl font-light text-ink/80">
                {item.label}
              </span>
              <span className="w-2 h-2 rounded-full bg-terracotta shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
